import React from "react";
import PropTypes from "prop-types";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import { withStyles } from "@material-ui/core/styles";
import "react-image-crop/dist/ReactCrop.css";
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@material-ui/core";
import moment from "moment";

function HistoryTableModal(props) {
  const {
    open,
    onClose,
    data,

    classes: { modal, modalContent, button, span },
  } = props;
  // console.log("data.history", data.history.history);
  return (
    <Dialog
      maxWidth={"md"}
      open={open}
      // disableBackdropClick
      onClose={onClose}
      classes={{ paper: modal }}
    >
      <DialogTitle>History of {data.name}'s profile </DialogTitle>
      <DialogContent classes={{ root: modalContent }}>
        <Table>
          {data.history !== null ? (
            <>
              <TableHead>
                <TableRow>
                  <TableCell>Date</TableCell>
                  <TableCell>Time</TableCell>
                  <TableCell>Action Taken</TableCell>
                  <TableCell>Reason</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data?.history?.history?.map((e, i) => {
                  return (
                    <TableRow key={i}>
                      <TableCell>{moment(e.date).format("DD/MM/YYYY")}{" "}</TableCell>
                      {/* <TableCell>{moment(e.date).format("HH:MM")}{" "}</TableCell> */}
                      <TableCell>{e.time}</TableCell>
                      <TableCell>{e.action}</TableCell>
                      <TableCell>{e.reason ? e.reason : "N/A"}</TableCell>
                    </TableRow>
                  )
                })}
                {/* <TableRow>
                  <TableCell>
                    {moment(data?.history?.date).format("DD/MM/YYYY")}{" "}
                  </TableCell>
                  <TableCell>
                    {moment(data?.history?.date).format("HH:MM")}{" "}
                  </TableCell>
                  <TableCell>Disabled</TableCell>
                  <TableCell>{data?.history?.reason}</TableCell>
                </TableRow> */}
              </TableBody>

            </>
          ) : (
            <>
              <TableHead sx={{ p: 3 }}>
                <h3 style={{ padding: " 25px", paddingBottom: "34px" }}>
                  No Data Found{" "}
                </h3>
              </TableHead>
            </>
          )}
        </Table>
      </DialogContent>
      <span className={span}>
        <Button
          onClick={onClose}
          variant="contained"
          color="primary"
          className={button}
        >
          Cancel
        </Button>
      </span>
    </Dialog>
  );
}

HistoryTableModal.propTypes = {
  open: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

const styles = () => ({
  modal: {
    maxHeight: "1000px",
  },
  modalContent: {
    overflow: "visible",
    padding: "10px",
    marginTop: "10px",
    textAlign: "center",
  },
  title: {
    marginTop: "10px",
    marginLeft: "auto",
    marginRight: "auto",
    padding: "5px",
  },
  button: {
    width: "100px",
    margin: "10px",
  },
  span: {
    margin: "auto",
    marginTop: "0px",
  },
});

export default withStyles(styles)(HistoryTableModal);
